import z from 'zod';

export const verifyEmailSearchSchema = z.object({
    token: z.string().min(1),
});
